module.exports = __webpack_public_path__ + "img/dog-health.ed2df91f.png";